import { render, staticRenderFns } from "./UserPointsRecords.vue?vue&type=template&id=ff5e4d36&scoped=true"
import script from "./UserPointsRecords.vue?vue&type=script&lang=js"
export * from "./UserPointsRecords.vue?vue&type=script&lang=js"
import style0 from "./UserPointsRecords.vue?vue&type=style&index=0&id=ff5e4d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5e4d36",
  null
  
)

export default component.exports